// Merchant request: a "back" button on product pages. Goes back one page in the browser history when the
// visitor came from this store; otherwise (direct visit, external link) it follows the link's href.
// Same-store detection uses the referrer, or window.mnCameFromStore (set in layout/theme.liquid from sessionStorage) when the referrer is hidden.
class SHistoryBack extends HTMLElement {
  connectedCallback() {
    this.link = this.querySelector('a');
    if (!this.link) return;
    this.onClick = (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      let sameOrigin = false;
      try {
        sameOrigin = document.referrer !== '' && new URL(document.referrer).origin === window.location.origin;
      } catch (_) {
        sameOrigin = false;
      }
      if ((sameOrigin || window.mnCameFromStore === true) && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      }
    };
    this.link.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.link?.removeEventListener('click', this.onClick);
  }
}

if (!customElements.get('s-history-back')) customElements.define('s-history-back', SHistoryBack);
